import { useIntl } from 'react-intl';
import { IconAlertOctagon, IconAlertTriangle } from '@rossum/ui/icons/tabler';
import { Stack, SvgIcon } from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';
import { getColor } from '../helpers';

type OverusedBannerProps = {
  usedPercentage: number;
};

const OverusedBanner = ({ usedPercentage }: OverusedBannerProps) => {
  const intl = useIntl();
  const isOverused = usedPercentage >= 100;

  const colorType = getColor(usedPercentage);

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={1}
      sx={{
        borderRadius: borderRadius('s'),
        backgroundColor: theme => theme.palette[colorType].main,
        color: theme => theme.palette[colorType].contrastText,
        padding: theme => theme.spacing(1),
      }}
    >
      <SvgIcon fontSize="large">
        {isOverused ? <IconAlertOctagon /> : <IconAlertTriangle />}
      </SvgIcon>
      {intl.formatMessage({
        id: isOverused
          ? 'containers.billing.overview.overusedError'
          : 'containers.billing.overview.overusedWarning',
      })}
    </Stack>
  );
};

export { OverusedBanner };
